import { AnyAction } from 'redux';
import { Store } from 'store/index';
import { ThunkDispatch } from 'redux-thunk';
import { AppBundle } from 'api/optimalprint-sdk.d';
import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { HttpMethods } from 'api/types';
import { setMatchingProductsAction } from '../slice';
import getCommonProductRequestParams from '../selector/getCommonProductRequestParams';

const fetchMatchingProducts =
  () => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const { locale, categoryId, encPublicDesignId, mobile } = getCommonProductRequestParams(store);

    const matchingProductsRequest: Partial<AppBundle.Api.Request.Category.V2.CategoryMatchingProductsListV2Request> = {
      categoryId,
      designIdEncrypted: encPublicDesignId,
      isMobile: mobile,
      locale,
    };

    const matchingProductsData = (await apiRequest(
      endpoints.categoryV2MatchingProductsList,
      matchingProductsRequest,
      HttpMethods.GET,
      'data',
    )) as AppBundle.Api.Response.Category.V2.CategoryMatchingProductsListV2Response;

    dispatch(setMatchingProductsAction(matchingProductsData.matchingProducts));
  };

export default fetchMatchingProducts;
